import { Component, input, Input } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { DateTime } from 'luxon';

import { PagedList } from '../../core/models/paged-list';
import { Message } from '../../core/models/message';
import { Router, UrlTree } from '@angular/router';

@Component({
  selector: 'app-message-list',
  templateUrl: './message-list.component.html',
  styleUrl: './message-list.component.scss'
})
export class MessageListComponent {
  defaultColumns: string[] = [];

  constructor(private router: Router){

    this.defaultColumns = this.isSearchPage() ? ['unread', 'subject', 'folder', 'received', 'attachment', 'link'] : ['unread', 'subject', 'received', 'attachment', 'link'];

  }

  DateTime = DateTime;

  
  displayedColumns = this.defaultColumns;

  internalPagedMessages: PagedList<Message> | undefined;

  ureadMessages: Message[] = [];

  dataSource = new MatTableDataSource(this.pagedMessages?.items);

  isSentPage(): boolean {
    return this.router.url === '/sent';
  }

  isSearchPage(): boolean {
    return this.router.url === '/messages'; 
  }

  getReceivedColumnName(): string {
    if(this.isSentPage()) {
      return 'Sent';
    }
    if(this.isSearchPage()){
      return 'Sent/Received';
    }
    return 'Received';
  }


  getCloseViewMessageRouterLink(element: Message): UrlTree {

    return this.router.createUrlTree(['/messages', element.id], { queryParams: { returnUrl: this.router.url } });

  }

  getFolderName(element: any): string {
    return element.fromClient == true ? 'Sent' : 'Inbox';
  }

  @Input()
  set pagedMessages(pagedMessages: PagedList<Message> | undefined) {

    if (pagedMessages == null) {
      return;
    }

    this.internalPagedMessages = pagedMessages;
    this.dataSource.data = pagedMessages.items;
    this.ureadMessages = pagedMessages.items.filter(m => m.timeFirstRead == null && !m.fromClient);

    this.displayedColumns = this.defaultColumns;

    if (this.ureadMessages.length === 0) {
      this.displayedColumns = this.displayedColumns.filter(dc => dc !== 'unread');
    }
    if (pagedMessages.items.filter(m => m.numberOfAttachments > 0 || m.onlineQuestionnaireId != null).length === 0) {
      this.displayedColumns = this.displayedColumns.filter(dc => dc !== 'attachment');
    }
  }
}
